import React from "react";
import leftArrow from "../../assets/leftArrow.svg";
import stripeSuccess from "../../assets/stripeSuccess.svg";
import Layout from "../../shared/Layout/Layout";
import { useNavigate } from "react-router-dom"
import styles from "./SubscriptionSuccess.module.scss";

const SubscriptionSuccess = () => {
  const navigate = useNavigate()
  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.subContainer}>
          <div className={styles.leftArrow}>
            <img src={leftArrow} alt="go-back" />
          </div>

          <div className={styles.box}>
            <img src={stripeSuccess} alt="success" />
            <h1>Your Payment is Successful</h1>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Vitae eos
              soluta pariatur repellendus, similique quo ad eligendi.
            </p>
            <button onClick={() => navigate('/')}>Back to Home</button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SubscriptionSuccess;
